export const VuetifyMoneyOptions = {
  locale: 'en-US',
  prefix: '$',
  suffix: '',
  length: 11,
  precision: 2
};
